// extracted by mini-css-extract-plugin
module.exports = {"siderSection":"style_siderSection__1Zaw9","siderLeft":"style_siderLeft__E2IqS","tabs":"style_tabs__3S66o","active":"style_active__3XrpD","siderRight":"style_siderRight__2GoRo"};